import React from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router";
import { Link } from "react-router-dom";
import { Box, Paper, Tab, Tabs, makeStyles } from "@material-ui/core";
import { store } from "@store";
import locale from "@bonliva-crm/locale";
import { ContractsPriceTemplateSearchPage } from "./ContractsPriceTemplates/Search/ContractsPriceTemplatesSearchPage";
import { TgRequirementsSearchPage } from "./tg-requirements/tg-requirements-search-page";
import { CostCentersSearchPage } from "./cost-centers/cost-centers-search-page";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    flex: "1 0 0",
    padding: 0,
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    overflow: "hidden",
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    minHeight: 40,
  },
  tab: {
    minHeight: 40,
    textTransform: "none",
  },
  content: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    overflowY: "auto",
  },
}));

type Props = RouteComponentProps<any>;

const navItems = [
  { path: "contract_templates", label: locale.configEditor.contractTemplates },
  { path: "tg_requirements", label: locale.configEditor.tgRequirements, show: () => store().user.can("config-editor:read:all") },
  { path: "cost_centers", label: locale.configEditor.costCenters, show: () => store().user.can("config-editor:read:all") },
];

export const ConfigEditor = (props: Props) => {
  const classes = useStyles();
  const { tab } = props.match.params;
  const activeTab = tab ?? "contract_templates";
  const visibleNavItems = navItems.filter((item) => item.show === undefined || item.show());

  return (
    <Box className={classes.root}>
      <Paper className={classes.paper} elevation={1}>
        <Tabs
          value={activeTab}
          className={classes.tabs}
          indicatorColor="primary"
          textColor="primary"
        >
          {visibleNavItems.map((item) => (
            <Tab
              key={item.path}
              value={item.path}
              label={item.label}
              component={Link}
              to={`/config_editor/${item.path}`}
              className={classes.tab}
            />
          ))}
        </Tabs>
        <Box className={classes.content}>
          <Switch>
            <Route
              path="/config_editor/contract_templates"
              component={ContractsPriceTemplateSearchPage}
            />
            <Route
              path="/config_editor/tg_requirements"
              component={TgRequirementsSearchPage}
            />
            <Route
              path="/config_editor/cost_centers"
              component={CostCentersSearchPage}
            />
            <Redirect to="/config_editor/contract_templates" />
          </Switch>
        </Box>
      </Paper>
    </Box>
  );
};

export default ConfigEditor;
